/**
 * Copyright (C) 2021-2026 Technology Matters
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published
 * by the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see https://www.gnu.org/licenses/.
 */

// Config reducer actions
export const ACTION_LOAD_CONFIG_REQUEST = 'ACTION_LOAD_CONFIG_REQUEST';
export const ACTION_LOAD_CONFIG_SUCCESS = 'ACTION_LOAD_CONFIG_SUCCESS';
export const ACTION_LOAD_CONFIG_FAILURE = 'ACTION_LOAD_CONFIG_FAILURE';
export const ACTION_CHANGE_LOCALE = 'ACTION_CHANGE_LOCALE';

// Chat reducer actions
export const ACTION_CHANGE_EXPANDED_STATUS = 'ACTION_CHANGE_EXPANDED_STATUS';
export const ACTION_CHANGE_ENGAGEMENT_PHASE = 'ACTION_CHANGE_ENGAGEMENT_PHASE';
export const ACTION_START_SESSION = 'ACTION_START_SESSION';
export const ACTION_UPDATE_PARTICIPANT = 'ACTION_UPDATE_PARTICIPANT';
export const ACTION_ADD_PARTICIPANT = 'ACTION_ADD_PARTICIPANT';
export const ACTION_REMOVE_PARTICIPANT = 'ACTION_REMOVE_PARTICIPANT';
export const ACTION_UPDATE_MESSAGE = 'ACTION_UPDATE_MESSAGE';
export const ACTION_ADD_MESSAGE = 'ACTION_ADD_MESSAGE';
export const ACTION_REMOVE_MESSAGE = 'ACTION_REMOVE_MESSAGE';
export const ACTION_ADD_MULTIPLE_MESSAGES = 'ACTION_ADD_MULTIPLE_MESSAGES';
export const ACTION_ATTACH_FILES = 'ACTION_ATTACH_FILES';
export const ACTION_DETACH_FILES = 'ACTION_DETACH_FILES';
export const ACTION_UPDATE_CONVERSATION_STATE = 'ACTION_UPDATE_CONVERSATION_STATE';

// Session reducer actions
export const ACTION_UPDATE_SESSION_DATA = 'ACTION_UPDATE_SESSION_DATA';
export const ACTION_UPDATE_PRE_ENGAGEMENT_DATA = 'ACTION_UPDATE_PRE_ENGAGEMENT_DATA';
export const ACTION_UPDATE_PARTICIPANT_NAME = 'ACTION_UPDATE_PARTICIPANT_NAME';
export const ACTION_UPDATE_CONVERSATION_ATTRIBUTES = 'ACTION_UPDATE_CONVERSATION_ATTRIBUTES';
export const ACTION_UPDATE_RECAPTCHA_VALIDITY = 'ACTION_UPDATE_RECAPTCHA_VALIDITY';

// Notification reducer actions
export const ACTION_ADD_NOTIFICATION = 'ACTION_ADD_NOTIFICATION';
export const ACTION_REMOVE_NOTIFICATION = 'ACTION_REMOVE_NOTIFICATION';

// Operating hours actions
export const ACTION_SET_OPERATING_HOURS_MESSAGE = 'ACTION_SET_OPERATING_HOURS_MESSAGE';
export const ACTION_SET_IP_ADDRESS = 'ACTION_SET_IP_ADDRESS';
export const ACTION_SET_CONTACT_IDENTIFIER = 'ACTION_SET_CONTACT_IDENTIFIER';
